import { EXTERNAL_NAME } from '@meltwater/applet-host/cjs/external-name';

import type { IAppletHostError, IFormattedDateTime, IAppletHostErrorCode } from './types.d';
const AppletHostModule = window[EXTERNAL_NAME] || ({} as any);

export const AppletHost = AppletHostModule.AppletHost;
export const AppletHostError: IAppletHostError = AppletHostModule.AppletHostError;
export const FormattedDateTime: IFormattedDateTime = AppletHostModule.FormattedDateTime;
export const MOMENT_FORMAT_STRING: string = AppletHostModule.MOMENT_FORMAT_STRING;
export const AppletHostErrorCode: IAppletHostErrorCode = AppletHostModule.AppletHostErrorCode;
